'use client';

import {
	BN,
	VelocityClient,
	PerpMarketConfig,
	User,
} from '@velocity-exchange/sdk';
import { useAccountTradingDataSync } from './useAccountTradingDataSync';
import { useTriggeredOrderNotifications } from './useTriggeredOrderNotifications';
import { useExpiredOrderNotifications } from './useExpiredOrderNotifications';

type Props = {
	userKey: string;
	user: User;
	velocityClient: VelocityClient;
	perpMarketsLookup: PerpMarketConfig[];
	markPriceCallback: (marketIndex: number) => BN;
};

/**
 * Per-account component that syncs trading data to React Query cache
 * and handles side effects (triggered order notifications).
 *
 * One instance is rendered per subaccount by AccountTradingDataProvider.
 */
export default function AccountTradingDataSync({
	userKey,
	user,
	velocityClient,
	perpMarketsLookup,
	markPriceCallback,
}: Props) {
	// Push all trading data to RQ cache (event-driven + polling fallback)
	useAccountTradingDataSync(
		userKey,
		user,
		velocityClient,
		perpMarketsLookup,
		markPriceCallback
	);

	useTriggeredOrderNotifications(userKey, user);
	useExpiredOrderNotifications(userKey, user);

	return null;
}
